import React, { useEffect, useState } from "react";
import { Table } from "antd";
import IntactRateChart from "./intactRateChart";
import SystemApi from "../../../../api/sys";
import RenderTxt from "../../../../components/renderTxt";

export default ({ deviceId }) => {
  const [chartData, setChartData] = useState({});
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [rating, setRating] = useState(0);
  const columns = [
    {
      title: "故障原因",
      dataIndex: "alarmName",
      align: "center",
      key: "alarmName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "次数",
      dataIndex: "times",
      align: "center",
      key: "times",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "权重",
      dataIndex: "weight",
      align: "center",
      key: "weight",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "占比",
      dataIndex: "proportion",
      align: "center",
      key: "proportion",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
  ];

  useEffect(() => {
    if (deviceId) {
      getList();
    }
  }, [deviceId]);

  const getList = () => {
    setLoading(true);
    SystemApi.listIntegrityRate({ id: deviceId }).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { integrityRateList, healthScore } = res.data;

      const seriesData = [];

      integrityRateList &&
        integrityRateList.forEach((item, index) => {
          item.key = index + 1;
          seriesData.push({
            name: item.alarmName,
            value: item.proportion.replace("%", "") * 1,
          });
        });
      const options = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          data: integrityRateList.map((item) => item.alarmName),
        },
        series: [
          {
            name: "完好率",
            type: "pie",
            radius: "50%",
            data: seriesData,
            label: {
              show: true,
              formatter: "{b}: {d}",
            },
          },
        ],
      };
      setChartData(options);
      setRating(healthScore);
      setDataSource(integrityRateList);
    });
  };

  return (
    <div style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
      <div className="intact-rate-l" style={{ width: 400 }}>
        <IntactRateChart
          id="intactRateChart"
          height={400}
          chartData={chartData}
        />
        <Table
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={false}
        />
      </div>
      <div
        className="intact-rate-r"
        style={{ width: "calc(100% - 400px)", paddingLeft: 200 }}
      >
        <p>
          设备健康评分
          <b style={{ fontSize: 40, color: "#27F048", paddingLeft: 20 }}>
            {rating}
          </b>
        </p>
        <p>设备目前处于健康运行状态</p>
      </div>
    </div>
  );
};
